import { Directive } from '@angular/core';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';
import { BaseFormConnectorDirective } from './base-form-connector.directive';

@Directive({
  selector: '[dsdExtRadioGroupConnector], dsd-radio-group',
  providers: [
    {
      provide: FormErrorConnectorDirective,
      useExisting: RadioGroupConnectorDirective
    }
  ],
  standalone: false
})
export class RadioGroupConnectorDirective extends BaseFormConnectorDirective {}
